import { useState } from "react";
import { supabase } from "@/libs/supabase";
import { useAuth } from "@/hooks/useAuth";

interface CreatePostParams {
	channelId: string;
	content: string;
}

export const useCreatePost = () => {
	const [loading, setLoading] = useState(false);
	const { user } = useAuth();

	const createPost = async ({ channelId, content }: CreatePostParams) => {
		if (!user) throw new Error("認証が必要です");

		setLoading(true);
		try {
			// チャンネルの種類を確認
			const { data: channel, error: channelError } = await supabase
				.from("channels")
				.select("type")
				.eq("id", channelId)
				.single();

			if (channelError) throw channelError;

			// お知らせチャンネルの場合、管理者権限をチェック
			if (channel.type === "ANNOUNCEMENT") {
				const { data: userData, error: userError } = await supabase
					.from("users")
					.select("role")
					.eq("id", user.id)
					.single();

				if (userError) throw userError;
				if (userData.role !== "admin") {
					throw new Error("お知らせチャンネルへの投稿権限がありません");
				}
			}

			const { data, error } = await supabase
				.from("posts")
				.insert([
					{
						channel_id: channelId,
						user_id: user.id,
						content,
					},
				])
				.select(`
          *,
          user:users(*),
          comments:comments(
            *,
            user:users(*)
          ),
          reactions:reactions(*)
        `);

			if (error) throw error;
			return data[0];
		} finally {
			setLoading(false);
		}
	};

	return { createPost, loading };
};
